import AddRoomTemplate from "../../../templates/admin/addRoom";

const AddRoomScreen = () => {
  return <AddRoomTemplate />;
};

export default AddRoomScreen;
